import { z } from "zod";

import {
  FileSchema,
  RegularIconSchema,
} from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

export const BackgroundMediaSchema = z.object({
  id: z.number().int().positive(),
  type: z.enum(["image", "video"]),
  image: StrapiMediaSchema.optional().nullable(),
  video: StrapiMediaSchema.optional().nullable(),
});

export const TrailSchema = z.object({
  id: z.number().int().positive(),
  order: z.number().int().positive(),
  uid: z.string().min(1),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  title: z.string().min(1),
  description: z.string().optional().nullable(),
  trailType: z.enum(["trail", "cable-way"]),
  trailNumber: z.string().optional().nullable(),
  length: z.string().min(1),
  workingHours: z.string().optional().nullable(),
  trailStatus: z.enum(["close", "open"]),
  difficulty: z
    .enum(["very hard", "hard", "medium", "easy"])
    .optional()
    .nullable(),
  image: StrapiMediaSchema.optional().nullable(),
  icon: RegularIconSchema.optional().nullable(),
  gallery: z.array(BackgroundMediaSchema).min(0).optional(),
  start: z.number().optional().nullable(),
  startDescription: z.string().optional().nullable(),
  end: z.number().optional().nullable(),
  endDescription: z.string().optional().nullable(),
  trackFiles: z.array(FileSchema).min(0).optional(),
  ascentTime: z.string().optional().nullable(),
  descentTime: z.string().optional().nullable(),
  capacity: z.string().optional().nullable(),
  comingSoon: z.string().optional().nullable(),
  seo: SeoSchema.optional().nullable(),
});
